import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { Locale } from '$shared/components/address-widget-picker/model/address-widget-picker-configuration';
import { filter, map } from 'rxjs/operators';
import { AuthenticationService } from '$core/services/auth.service';
import { SessionService } from '$core/services/session.service';
import { environment } from '$env/environment';
import { ContactBookConfiguration } from '$modules/personal/contacts/model/contact-book-configuration';
import { transformBelpostUserTypeToWidgetUserType } from '$shared/components/address-widget-picker/model/address-widget-user-type';

@Injectable()
export class ContactBookConfigurationService {
  private readonly token$ = this.authenticationService.getAccessTokenReactive();
  private readonly defaultUserType$ = this.sessionService.session$.pipe(
    filter((User) => !!User),
    map((user) => transformBelpostUserTypeToWidgetUserType(user.type))
  );

  public readonly configuration$: Observable<ContactBookConfiguration> =
    combineLatest([this.token$, this.defaultUserType$]).pipe(
      filter(
        ([token, defaultUserType]) => token !== null && defaultUserType !== null
      ),
      map(([token, defaultUserType]) => ({
        authorization: token,
        context: 'batch-mailing',
        locale: this.mapLocale(),
        user: {
          person: {
            type: defaultUserType,
          },
        },
        apiUrl: `${environment.serverUrl}/v1`,
      }))
    );

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly sessionService: SessionService,
    @Inject(LOCALE_ID) private locale: 'ru' | 'en' | 'by'
  ) {}

  private mapLocale(): Locale {
    switch (this.locale) {
      case 'ru': {
        return this.locale;
      }
      case 'en': {
        return this.locale;
      }
      case 'by': {
        return 'be';
      }
    }
  }
}
